export const ADD = 'Add';
export const ALERT_EXPLANATION = 'AlertExplanation';
export const CALENDAR = 'Calendar';
export const CALLBACK = 'Callback';
export const CARET_DOWN = 'CaretDown';
export const CARET_LEFT = 'CaretLeft';
export const CARET_LEFT_SMALL = 'CaretLeftSmall';
export const CARET_RIGHT = 'CaretRight';
export const CARET_UP = 'CaretUp';
export const CHAT = 'Chat';
export const CHECKMARK = 'Checkmark';
export const FLAG = 'Flag';
export const HOME_OUTLINE = 'HomeOutline';
export const HOME_SOLID = 'HomeSolid';
export const LOG = 'Log';
export const PHONE = 'Phone';
export const QUESTION = 'Question';
export const RESTART = 'Restart';
export const SHARE = 'Share';
export const VERTICAL_DOTS = 'VerticalDots';
export const LOADER_RING = 'LoaderRing';
export const HIDE_THICK = 'HideThick';
export const SHOW_THICK = 'ShowThick';
export const ALERT_EXPLANATION_LITE = 'AlertExplanationLite';
export const EXTERNAL = 'External';
export const NO_PERMISSIONS = 'NoPermissions';
export const INFO = 'Info';
export const NOT_AVAILABLE = 'NotAvailable';
export const CLOSE_BUTTON = 'CloseButton';
export const SEND_ICON = 'SendIcon';
export const ERROR_ICON = 'ErrorIcon';
export const PREMIUMUSER_BUTTON = 'PremiumUserButton';
export const STANDARDUSER_BUTTON = 'StandardUserButton';
export const AUTODESK_AVATAR_ICON = 'AutodeskAvatarIcon';
export const DOWNLOAD_ICON = 'DownloadIcon';
export const CLOSE_ICON = 'CloseIcon';
export const ATTACH_ICON = 'AttachIcon';
export const FILE_ICON = 'FileIcon';
export const SHEERID_ICON = 'SheerId';


export default {
  ADD,
  ALERT_EXPLANATION,
  ALERT_EXPLANATION_LITE,
  CALENDAR,
  CALLBACK,
  CARET_DOWN,
  CARET_LEFT,
  CARET_LEFT_SMALL,
  CARET_RIGHT,
  CARET_UP,
  CHAT,
  CHECKMARK,
  FLAG,
  HOME_OUTLINE,
  HOME_SOLID,
  LOG,
  PHONE,
  QUESTION,
  RESTART,
  SHARE,
  VERTICAL_DOTS,
  LOADER_RING,
  HIDE_THICK,
  SHOW_THICK,
  EXTERNAL,
  NO_PERMISSIONS,
  INFO,
  NOT_AVAILABLE,
  CLOSE_BUTTON,
  SEND_ICON,
  ERROR_ICON,
  PREMIUMUSER_BUTTON,
  STANDARDUSER_BUTTON,
  AUTODESK_AVATAR_ICON,
  DOWNLOAD_ICON,
  CLOSE_ICON,
  ATTACH_ICON,
  FILE_ICON,
  SHEERID_ICON
};
